import React, { ReactNode } from 'react';
import Card from '../ui/Card';

interface ContentContainerProps {
  children: ReactNode;
  filterContent?: ReactNode;
}

/**
 * ContentContainer - A consistent container for content without tabs
 * Provides standardized layout for pages without tab navigation
 * - filterContent: Optional filter controls that appear at the top
 * - children: The main content area
 */
const ContentContainer: React.FC<ContentContainerProps> = ({ 
  children, 
  filterContent 
}) => {
  return (
    <Card className="w-full">
      <div className="p-3">
        {/* Filters section if provided */}
        {filterContent && (
          <div className="pb-3 border-b border-gray-200 mb-3">
            {filterContent}
          </div>
        )}
        
        {/* Main content area with consistent padding */}
        <div>
          {children}
        </div>
      </div>
    </Card>
  );
};

export default ContentContainer;
